import React from "react"
import styled from "styled-components"
import { SectionWrapper } from "../../components/common/wrappers/Wrappers"
import { breakpoint } from "../../configs/utilities"
import {
  PageDescription,
  PageTitle,
  PageTitleDescription,
} from "../../components/common/typography/Typography"

const HeroCreatePagesSection = ({
  name,
  titleDescription,
  pageDescription,
}) => {
  return (
    <Wrapper>
      <SectionWrapper
        paddingSm="15px 20px"
        paddingmd="30px 30px"
        paddingXl="50px 50px"
      >
        <Content>
          <PageTitle maxWidthSm="500px" maxWidthMd="750px" maxWidthXl="1000px">
            {name}
          </PageTitle>
          {titleDescription && (
            <PageTitleDescription>{titleDescription}</PageTitleDescription>
          )}
          {pageDescription && (
            <PageDescription className="pageDescription">
              {pageDescription}
            </PageDescription>
          )}
        </Content>
      </SectionWrapper>
    </Wrapper>
  )
}

export default HeroCreatePagesSection

const Wrapper = styled.div``

const Content = styled.div`
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.xl}) {
    max-width: 1200px;
  }

  .pageDescription {
    margin-top: 40px;
  }
`
